import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';

import { StorageService } from './storage.service';
import { TarefaService } from '../tarefa-service/tarefa.service';
import { FolhaServicoService } from '../folha-servico-service/folha-servico.service';
import { JornadaService } from '../jornada-service/jornada.service';
import { JornadaServicoService } from '../jornada-servico/jornada-servico.service';
import { PosicionamentoService } from '../posicionamento-service/posicionamento.service';

@Injectable({ providedIn: 'root' })
export class SyncService {
  constructor(
    private storageService: StorageService,
    private tarefaService: TarefaService,
    private folhaServicoService: FolhaServicoService,
    private jornadaService: JornadaService,
    private jornadaServicoService: JornadaServicoService,
    private posicionamentoService: PosicionamentoService

  ) {
    this.listenForNetworkChanges();
    //console.log('SyncService inicializado');
  }

  private async listenForNetworkChanges() {
    Network.addListener('networkStatusChange', async (status) => {
      if (status.connected) {
        await this.syncTasksWithBackend();
        await this.syncJornadaServicoWithBackend();
        await this.syncPosicionamentosWithBackend();
        //await this.syncFolhasServicoWithBackend();
        //await this.syncJornadasWithBackend();
      }
    });
  }

  private async syncTasksWithBackend() {
    const tarefasPendentes = await this.storageService.getTarefasNaoSincronizadas();
    //console.log('Tarefas para sincronizar:', JSON.stringify(tarefasPendentes));

    for (const tarefa of tarefasPendentes) {
      try {
        // ✅ 1. Cancelar tarefa (tem prioridade máxima)
        if (tarefa.motivoCancelamento && !tarefa.sincronizadoCancelamento) {
          const resposta = await firstValueFrom(this.tarefaService.cancelarTarefa(
            tarefa.id,
            tarefa.horaFim || '',
            tarefa.motivoCancelamento,
            Number(tarefa.latitude),
            Number(tarefa.longitude)
          ));
          //console.log(`Resposta do cancelamento: ${JSON.stringify(resposta)}`);

          await this.storageService.marcarCancelamentoComoSincronizado(tarefa.id);
          //console.log(`Tarefa ${tarefa.id} cancelada e sincronizada.`);
          continue;
        }

        // ✅ 2. Finalizar tarefa
        if (tarefa.horaFim && !tarefa.sincronizadoFim) {
          const resposta = await firstValueFrom(this.tarefaService.finalizarTarefa(
            tarefa.id,
            tarefa.horaFim,
            Number(tarefa.hodometroFinal || 0),
            Number(tarefa.catracaFinal || 0),
            Number(tarefa.latitude),
            Number(tarefa.longitude)
          ));
          //console.log(`Resposta da finalização: ${JSON.stringify(resposta)}`);

          await this.storageService.marcarFimComoSincronizado(tarefa.id);
          //console.log(`Tarefa ${tarefa.id} finalizada e sincronizada.`);
          continue;
        }

        // ✅ 3. Iniciar tarefa
        if (tarefa.horaInicio && !tarefa.sincronizadoInicio) {
          const resposta = await firstValueFrom(this.tarefaService.iniciarTarefa(
            tarefa.id,
            tarefa.horaInicio,
            Number(tarefa.latitude),
            Number(tarefa.longitude)
          ));
          //console.log(`Resposta do início: ${JSON.stringify(resposta)}`);

          await this.storageService.marcarInicioComoSincronizado(tarefa.id);
          //console.log(`Tarefa ${tarefa.id} iniciada e sincronizada.`);
          continue;
        }

      } catch (error: any) {
        const status = error?.status;
        const msg = error?.error?.error || error?.message || JSON.stringify(error);

        //console.error(`Erro ao sincronizar tarefa ${tarefa.id}: ${msg}`);

        // ✅ Tratamento genérico para erro 404: assume que a tarefa já foi processada
        if (status === 404) {
          const marcar = [];

          if (tarefa.horaInicio && !tarefa.sincronizadoInicio) {
            marcar.push(this.storageService.marcarInicioComoSincronizado(tarefa.id));
          }
          if (tarefa.horaFim && !tarefa.sincronizadoFim) {
            marcar.push(this.storageService.marcarFimComoSincronizado(tarefa.id));
          }
          if (tarefa.motivoCancelamento && !tarefa.sincronizadoCancelamento) {
            marcar.push(this.storageService.marcarCancelamentoComoSincronizado(tarefa.id));
          }

          await Promise.all(marcar);
          console.warn(`Tarefa ${tarefa.id} retornou 404. Marcada como sincronizada para todos os estados aplicáveis.`);
        }
      }
    }
  }

  /** Converte "HH:mm" em minutos desde meia-noite */
  private convertHourStringToNumber(hourStr: string): number {
    if (!hourStr) return 0;
    const [hours, minutes] = hourStr.split(':').map(Number);
    return hours * 60 + minutes;
  }

  /*private async syncJornadaServicoWithBackend() {
    const registros = await this.storageService.getJornadaServicosNaoSincronizados();

    for (const reg of registros) {
      const id = reg.id;

      // 🔹 Início da Jornada
      if (!reg.jornadaInicioSincronizado) {
        try {
          await this.jornadaServicoService.iniciarJornadaServicoOffline(reg);
          await this.storageService.marcarInicioJornadaServicoSincronizado(id);
          console.log(`✅ Jornada ${id} - início sincronizado.`);
        } catch (erro: any) {
          console.error(`❌ Erro ao sincronizar início da jornada ${id}:`, erro?.status);

          // Se der erro, marca como sincronizado mesmo assim pra não travar
          if (erro?.status === 400 || erro?.status === 403 || erro?.status === 409) {
            await this.storageService.marcarInicioJornadaServicoSincronizado(id);
          }
        }
        continue; // PULA para o próximo registro, não tenta finalizar agora
      }

      // 🔹 SÓ TENTA FINALIZAR SE TIVER HORA FINAL PREENCHIDA!
      //if (reg.jornadaInicioSincronizado && !reg.jornadaFimSincronizado) {
      if (reg.jornadaInicioSincronizado && (reg.hasOwnProperty("jornadaFimSincronizado") && !reg.jornadaFimSincronizado)) {

        // VALIDAÇÃO CRÍTICA: Só finaliza se tiver hora_final
        if (!reg.hora_final && !reg.horaFinal) {
          console.log(`⏳ Jornada ${id} ainda está ABERTA (sem hora final). Não vai finalizar.`);
          continue; // PULA, não tenta finalizar
        }

        try {
          await this.jornadaServicoService.finalizarJornadaServicoOffline(reg);
          await this.storageService.marcarFimJornadaServicoSincronizado(id);
          console.log(`✅ Jornada ${id} - fim sincronizado.`);
        } catch (erro: any) {
          console.error(`❌ Erro ao sincronizar fim da jornada ${id}:`, erro?.status);

          if (erro?.status === 400 || erro?.status === 403 || erro?.status === 404) {
            await this.storageService.marcarFimJornadaServicoSincronizado(id);
          }
        }
      }
    }
  }*/

  private async syncJornadaServicoWithBackend() {
  const registros = await this.storageService.getJornadaServicosNaoSincronizados();
  console.log(`📊 Iniciando sincronização de ${registros.length} jornada(s)...`);

  for (const reg of registros) {
    const id = reg.id;
    
    console.log(`🔄 Processando jornada ID: ${id}`, {
      folha_servico_id: reg.folha_servico_id,
      numero_papeleta: reg.numero_papeleta,
      hora_inicial: reg.hora_inicial || reg.horaInicial,
      hora_final: reg.hora_final || reg.horaFinal,
      offline: reg.offline,
      url: 'https://i9fluir.com.br:8082/api/jornada-servico'
    });

    // 🔹 Início da Jornada
    if (!reg.jornadaInicioSincronizado) {
      console.log(`🚀 Tentando sincronizar INÍCIO da jornada ${id}...`);
      
      try {
        console.log(`📤 Enviando requisição para INÍCIO:`, reg);
        const response = await this.jornadaServicoService.iniciarJornadaServicoOffline(reg);
        console.log(`✅ Jornada ${id} - INÍCIO sincronizado!`, response);
        await this.storageService.marcarInicioJornadaServicoSincronizado(id);
        
      } catch (erro: any) {
        console.error(`❌ ERRO ao sincronizar INÍCIO da jornada ${id}:`);
        
        // Diagnóstico detalhado do erro
        if (erro.status === 0) {
          console.error(`   🔴 ERRO DE REDE OU CORS!`);
          console.error(`   Possíveis causas:`);
          console.error(`   - Servidor offline: https://i9fluir.com.br:8082`);
          console.error(`   - CORS não configurado`);
          console.error(`   - Certificado SSL inválido`);
          console.error(`   - Firewall bloqueando`);
          console.error(`   - Timeout de conexão`);
        }
        
        console.error(`   - Status: ${erro?.status || 'sem status'}`);
        console.error(`   - Status Text: ${erro?.statusText || 'sem status text'}`);
        console.error(`   - Mensagem: ${erro?.message || 'sem mensagem'}`);
        console.error(`   - URL: ${erro?.url || 'URL não disponível'}`);
        console.error(`   - Nome do erro: ${erro?.name || 'sem nome'}`);
        console.error(`   - Tipo: ${erro?.type || 'sem tipo'}`);
        
        if (erro?.error) {
          console.error(`   - Erro detalhado:`, erro.error);
        }

        // Verifica se é um ProgressEvent (erro de rede)
        if (erro.error instanceof ProgressEvent) {
          console.error(`   🔴 PROGRESS EVENT DETECTADO:`);
          console.error(`   - Tipo: ${erro.error.type}`);
          console.error(`   - Bubbles: ${erro.error.bubbles}`);
          console.error(`   - Cancelable: ${erro.error.cancelable}`);
          console.error(`   - Timeout: ${erro.error.timeout}ms`);
          console.error(`   - Carregado: ${erro.error.loaded} bytes`);
          console.error(`   - Total: ${erro.error.total} bytes`);
          console.error(`   - Length Computable: ${erro.error.lengthComputable}`);
        }

        // Se der erro, marca como sincronizado mesmo assim pra não travar
        if (erro?.status === 400 || erro?.status === 403 || erro?.status === 409) {
          console.log(`⚠️ Jornada ${id} - Marcando INÍCIO como sincronizado (erro ${erro.status})`);
          await this.storageService.marcarInicioJornadaServicoSincronizado(id);
        } else if (erro?.status === 0) {
          console.log(`⚠️ Jornada ${id} - Erro de rede, não vamos marcar como sincronizado.`);
          console.log(`⚠️ A jornada permanecerá pendente para nova tentativa.`);
        }
      }
      continue;
    }

    // 🔹 Final da Jornada
    if (reg.jornadaInicioSincronizado && !reg.jornadaFimSincronizado) {
      const horaFinal = reg.hora_final || reg.horaFinal;
      if (!horaFinal) {
        console.log(`⏳ Jornada ${id} - Sem hora final, aguardando...`);
        continue;
      }

      console.log(`🏁 Tentando sincronizar FIM da jornada ${id} com hora final: ${horaFinal}...`);

      try {
        console.log(`📤 Enviando requisição para FIM:`, reg);
        const response = await this.jornadaServicoService.finalizarJornadaServicoOffline(reg);
        console.log(`✅ Jornada ${id} - FIM sincronizado!`, response);
        await this.storageService.marcarFimJornadaServicoSincronizado(id);
        
      } catch (erro: any) {
        console.error(`❌ ERRO ao sincronizar FIM da jornada ${id}:`);
        
        // Diagnóstico detalhado do erro
        if (erro.status === 0) {
          console.error(`   🔴 ERRO DE REDE OU CORS!`);
          console.error(`   Possíveis causas:`);
          console.error(`   - Servidor offline: https://i9fluir.com.br:8082`);
          console.error(`   - CORS não configurado`);
          console.error(`   - Certificado SSL inválido`);
          console.error(`   - Firewall bloqueando`);
          console.error(`   - Timeout de conexão`);
        }
        
        console.error(`   - Status: ${erro?.status || 'sem status'}`);
        console.error(`   - Status Text: ${erro?.statusText || 'sem status text'}`);
        console.error(`   - Mensagem: ${erro?.message || 'sem mensagem'}`);
        console.error(`   - URL: ${erro?.url || 'URL não disponível'}`);
        console.error(`   - Nome do erro: ${erro?.name || 'sem nome'}`);
        
        if (erro?.error) {
          console.error(`   - Erro detalhado:`, erro.error);
        }

        // Verifica se é um ProgressEvent (erro de rede)
        if (erro.error instanceof ProgressEvent) {
          console.error(`   🔴 PROGRESS EVENT DETECTADO:`);
          console.error(`   - Tipo: ${erro.error.type}`);
          console.error(`   - Bubbles: ${erro.error.bubbles}`);
          console.error(`   - Cancelable: ${erro.error.cancelable}`);
          console.error(`   - Timeout: ${erro.error.timeout}ms`);
          console.error(`   - Carregado: ${erro.error.loaded} bytes`);
          console.error(`   - Total: ${erro.error.total} bytes`);
        }

        // Tratamento para erro de rede (não marca como sincronizado)
        if (erro?.status === 400 || erro?.status === 403 || erro?.status === 404) {
          console.log(`⚠️ Jornada ${id} - Marcando FIM como sincronizado (erro ${erro.status})`);
          await this.storageService.marcarFimJornadaServicoSincronizado(id);
        } else if (erro?.status === 0) {
          console.log(`⚠️ Jornada ${id} - Erro de rede, NÃO vamos marcar como sincronizado.`);
          console.log(`⚠️ A jornada será tentada novamente na próxima sincronização.`);
        }
      }
    }
  }
  
  console.log('🏁 Sincronização de jornadas concluída!');
}

  private async syncPosicionamentosWithBackend() {
    const pendentes = await this.storageService.getPosicionamentosNaoSincronizados();
    //console.log('Posicionamentos para sincronizar:', pendentes.length);

    for (const p of pendentes) {
      try {
        await this.posicionamentoService.enviarPosicionamento({
          data: p.data,
          horario: p.horario,
          latitude: p.latitude,
          longitude: p.longitude,
          trajetoId: p.trajetoId,
          veiculoId: p.veiculoId,
          motoristaId: p.motoristaId
        });

        await this.storageService.marcarPosicionamentoComoSincronizado(p.id_local);
        //console.log(`✅ Posicionamento ${p.id_local} sincronizado.`);
      } catch (erro: any) {
        //console.error(`❌ Erro ao sincronizar posicionamento ${p.id_local}:`, erro?.status || erro?.message || erro);
        if (erro?.status === 400 || erro?.status === 404) {
          await this.storageService.marcarPosicionamentoComoSincronizado(p.id_local);
          console.warn(`⚠️ ${p.id_local} retornou ${erro.status}; marcado como sincronizado.`);
        }
      }
    }
  }

}
